import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 14px;
  padding: 2%;
  bottom: 0;
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  font-family: "proxima-nova", sans-serif;

  & > div {
    font-size: 20px;
    font-family: "proxima-nova", sans-serif;
    padding-left: 25px;
    margin-top: 20px;
    margin-bottom: 20px;
    & > a {
      color: #ff4400;
      text-decoration: none;
    }
  }

  button {
    background: rgba(255, 65, 3, 1);
    font-weight: bold;
    border: none;
    cursor: pointer;
    color: white;
    font-family: "proxima-nova", sans-serif;
    padding: 8px 30px;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px !important;
  }

  @media (max-width: 950px) {
    justify-items: center;

    h4 {
      padding-top: 20px;
    }

    a {
      display: block;
    }

    & > div {
      padding-left: 0;
    }
  }

  @media (min-width: 950px) {
    > button {
      margin-left: 120px;
      margin-right: 60px;
      width: 200px;
      width: 510px;
    }
  }

  @media (min-width: 1300px) {
    > button {
      width: 350px;
    }
  }
`;

export const ContainerCookieInformation = styled.div`
  margin-left: 30px;
  margin-top: 130px;
  margin-right: 30px;
  font-family: "proxima-nova", sans-serif;
  & > div {
    overflow-x: scroll;
    & > table {
      > tbody > tr:nth-child(even),
      thead > tr {
        background-color: #dddddd;
        > th {
          padding: 10px;
        }
      }
      > tbody > tr {
        > td {
          padding: 10px;
        }
      }
    }
  }

  & > li {
    list-style: none;
    & > a {
      color: #337ab7;
    }
  }

  > table {
  }
`;

export const Title = styled.h2`
  font-family: "proxima-nova", sans-serif;
  & > span {
    color: #ea4e27;
  }
`;

export const subtitle = styled.h4`
  font-family: "proxima-nova", sans-serif;
  padding-left: 25px;
  margin: 0;
  font-size: 20px;

  @media (max-width: 950px) {
    padding-left: 0;
  }
`;

export const paragraph = styled.p`
  font-family: "proxima-nova", sans-serif;
  & > strong {
    font-weight: 800;
  }
  & > a {
    color: #337ab7;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  column-gap: 15px;
  width: 100%;

  @media (max-width: 950px) {
    flex-direction: column;
    gap: 10px;

    a {
      width: 100%;
      text-align: center;
    }
  }
`;

export const Button = styled.button`
  background: rgba(255, 65, 3, 1);
  font-weight: bold;
  border: none;
  cursor: pointer;
  color: white;
  font-family: "proxima-nova", sans-serif;
  padding: 8px 30px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px !important;
`;
